"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var Marquee = /** @class */ (function (_super) {
    tslib_1.__extends(Marquee, _super);
    function Marquee(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.scrollLeft = function () {
            utils_1.caf(_this.rafId);
            _this.rafId = utils_1.raf(function () {
                if (_this.props.active && !_this.willUnmount && _this.$el) {
                    var nodeRect = _this.$el.getBoundingClientRect();
                    var scrollUntil = Math.floor(_this.$el.scrollWidth - nodeRect.width);
                    if (scrollUntil > 0) {
                        if (_this.$el.scrollLeft < scrollUntil) {
                            _this.$el.scrollLeft += 1;
                            _this.scrollLeft();
                        }
                        else {
                            setTimeout(function () { return _this.scrollRight(); }, _this.props.waitTime);
                        }
                    }
                }
            });
        };
        _this.scrollRight = function () {
            utils_1.caf(_this.rafId);
            _this.rafId = utils_1.raf(function () {
                if (_this.props.active && !_this.willUnmount && _this.$el) {
                    if (_this.$el.scrollLeft > 0) {
                        _this.$el.scrollLeft -= 1;
                        _this.scrollRight();
                    }
                    else {
                        setTimeout(function () { return _this.scrollLeft(); }, _this.props.waitTime);
                    }
                }
            });
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.willUnmount = false;
        _this.$el = null;
        return _this;
    }
    Marquee.prototype.componentDidMount = function () {
        this.handleScroll({});
    };
    Marquee.prototype.componentDidUpdate = function (prevProps) {
        this.handleScroll(prevProps);
    };
    Marquee.prototype.handleScroll = function (prevProps) {
        var props = this.props;
        if (prevProps.active !== props.active || (props.active && props.children !== prevProps.children)) {
            utils_1.caf(this.rafId);
            if (props.active) {
                this.scrollLeft();
            }
            else {
                if (this.$el) {
                    this.$el.scrollLeft = 0;
                    this.$el = null;
                }
            }
        }
    };
    Marquee.prototype.render = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, children = _a.children, active = _a.active;
        var classes = classnames_1.default(theme.marquee, className);
        return (active ? (React.createElement("div", { ref: this.setRef, className: classes }, children)) : children);
    };
    Marquee.defaultProps = {
        waitTime: 2000
    };
    return Marquee;
}(React.Component));
exports.default = Marquee;
